import React, { Component, PropTypes } from 'react';
import { browserHistory, Link } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as sessionActions from '../actions/session-actions';

import LoginForm from '../components/LoginForm.js';
import PublicModal from '../components/PublicModal.js';

import './LoginPage.css';

class LoginPage extends Component {
  constructor(props) {
    super(props);

    this.onLogin = this.onLogin.bind(this);
    this.handleLogout = this.handleLogout.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    // If we get an update with `session.authenticated` as true, push the user
    // to the main app.
    if (nextProps.session.authenticated) {
      browserHistory.replace('/app/home');
    }
  }

  componentWillMount() {
    const { session } = this.props;
    if (session && session.token) {
      browserHistory.push('/app/home');
    }
  }

  onLogin(ev) {
    const { email, password } = ev;
    this.props.actions.requestUserLogin({ email, password });
  }

  handleLogout() {
    this.props.actions.requestUserLogout();
  }

  render() {
    let helpText = <p></p>;

    const { error: sessionError } = this.props.session;
    if (sessionError) {
      helpText = <p>We couldn’t log you in with those credentials. Please make sure your email and password are correct and try again.</p>;

      if (sessionError.description === 'Your account has been disabled') {
        helpText = <p>Your account has been disabled.</p>;
      }
    }

    return (
      <div className="LoginPage">
        <PublicModal centered={false}>
          <div className="col-sm-10 col-sm-push-1 col-lg-6 col-lg-push-3">
            <h1 className="LoginPage__header">Sign in to Normal Chat</h1>
            {helpText}
            <LoginForm isSubmitting={this.props.session.authenticating} error={sessionError} onSubmit={this.onLogin} />
            <Link to="/forgot-password" className="muted">Forgot your password?</Link>
          </div>
        </PublicModal>
      </div>
    );
  }
};

function mapStateToProps(state, props) {
  return {
    session: state.session
  };
};

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(sessionActions, dispatch)
  };
};

LoginPage.propTypes = {
  session: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);



// WEBPACK FOOTER //
// ./src/containers/LoginPage.js